import React, { useEffect, useState, useReducer } from 'react'
import { Col, Row, Input, Select, Button, List, message, Spin } from 'antd'
import inventorySrc from '../inventorySrc'
import Utils from '../../../utils/Utils'
import debounce from 'lodash/debounce'
import UISpinner from '../../../components/UISpinner'

const { Option } = Select

const initialState = {
  productCol: 12,
  unitsCol: 4,
  priceCol: 4,
  newQuantityColHide: true,
  remainingColHide: true,
}

const styleReducer = (style, action) => {
  switch (action.type) {
    case 'ENTRY':
      return {
        productCol: 8,
        unitsCol: 4,
        priceCol: 4,
        totalCol: 4,
        newQuantityColHide: true,
        remainingColHide: true,
      }
    case 'COUNT':
      return {
        productCol: 15,
        unitsCol: 5,
        priceColHide: true,
        totalColHide: true,
        newQuantityColHide: true,
        remainingColHide: true,
      }
    case 'ADJUSTMENT':
      return {
        productCol: 12,
        unitsColHide: true,
        totalColHide: true,
        priceColHide: true,
        remainingCol: 4,
        newQuantityCol: 4,
      }
    case 'TRANSFER':
      return {
        productCol: 15,
        unitsCol: 5,
        priceColHide: true,
        totalColHide: true,
        newQuantityColHide: true,
        remainingColHide: true,
      }
    default:
      throw new Error('Must set a listType prop in InventoryList component')
  }
}

function InventoryList(props) {
  const initDataSource = JSON.stringify([{ id: 1, product: null, units: '', price: '' }])
  const [productsList, setProductsList] = useState([])
  const [products, setProducts] = useState([])
  const [dataSource, setDataSource] = useState(JSON.parse(initDataSource))
  const [style, dispatch] = useReducer(styleReducer, initialState)
  const [data, setData] = useState([])
  const [fetching, setFetching] = useState(false)

  useEffect(() => {
    if (dataSource !== props.productsInventory) {
      props.products(dataSource)
    }
    if (props.listType === 'COUNT') {
      props.productsInfo(dataSource)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSource])

  useEffect(() => {
    if (props.listType === 'ADJUSTMENT' && props.productsInventory.length > 0) {
      if (props.productsInventory[0].product_id !== null) {
        setDataSource(props.productsInventory)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.productsInventory])

  useEffect(() => {
    setDataSource(JSON.parse(initDataSource))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.changeShop])

  useEffect(() => {
    props.visible && dispatch({ type: props.listType })
    if (typeof props.edit === 'object' && !Utils.isObjEmpty(props.edit)) {
      const formatProductsList = data => {
        let _productsList
        if (props.listType === 'ENTRY') {
          _productsList = data.map(p => ({
            id: p.item_line + 1,
            productName: p.presentation.description,
            units: p.quantity,
            price: p.unit_price,
          }))
        } else {
          _productsList = data.map(p => ({
            id: p.item_line + 1,
            product: p.product_id,
            units: p.quantity,
            price: p.unit_price,
          }))
        }
        setDataSource(_productsList)
      }
      formatProductsList(props.edit.purchase_details)
    }
    setData([])
    setProducts([])

    return () => {
      const sorted = dataSource.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id + 1 })
      const prevDataSource = [...sorted, newRow]
      const newDataSource = prevDataSource.flatMap((row, i) => (i < prevDataSource.length - 1 ? [] : row))
      setDataSource(newDataSource)
    }
    // eslint-disable-next-line
  }, [props.visible, props.edit, props.listType, initDataSource])

  useEffect(() => {
    if (props.productList) {
      setDataSource(JSON.parse(initDataSource))
      setProductsList(props.productList)
    }
    // eslint-disable-next-line
  }, [props.productList])

  const onAdd = () => {
    setDataSource(prevState => {
      const sorted = prevState.sort((a, b) => a.id - b.id)
      const lastItem = sorted[sorted.length - 1]
      const newRow = Object.assign(JSON.parse(initDataSource)[0], { id: lastItem.id + 1 })
      return [...sorted, newRow]
    })
  }

  const onSetData = (e, rowId, name, presentation = false) => {
    const inputName = name ? name : e.target.name
    const value = name ? parseInt(e) : e.target.value

    if (presentation) {
      const productName =
        data.find(p => p.id === value)?.description ||
        products.find(p => p.id === value)?.description ||
        productsList.find(p => p.product_id === value)?.description

      const newDataSource = dataSource.map(row => {
        if (row.id === rowId) {
          return Object.assign(row, { [inputName]: value, productName })
        }
        return row
      })

      setDataSource(newDataSource)
      setData([])
      setProducts([])
    } else {
      const newDataSource = dataSource.map(row => {
        if (row.id === rowId) {
          return Object.assign(row, { [inputName]: value })
        }
        return row
      })
      setDataSource(newDataSource)
    }
  }

  const onDelete = (e, rowId) => {
    if (dataSource.length === 1) return
    setDataSource(prevState => {
      const value = prevState.flatMap(row => (row.id !== rowId ? row : []))
      return value
    })
  }

  const fetchPresentations = async value => {
    if (value.length >= 3) {
      setData([])
      setFetching(true)
      const excludeChars = Utils.excludedCharsContent(value)
      const res = await inventorySrc.searchPresentations(value, excludeChars, 'desc')

      const shop = props.shopsList.find(item => item.id === props.selectedShop)
      
      let productsAux = []

      productsAux = res.data.filter((item) => {
          return item.product.store_chains.find((item) => item.id === shop.store_chain_id)
      });
      
      setData(productsAux)
      setFetching(false)
    }
  }

  const onSearchProducts = val => {
    if (props.productList) {
      const _products = productsList.filter(pl => pl.description.toLowerCase().indexOf(val.toLowerCase()) > -1)
      setProducts(_products)
    } else {
      if (val.length >= 3) {
        setFetching(true)
        const excludeChars = Utils.excludedCharsContent(val)
        Utils.getProductsOption(val, excludeChars, 'desc')
          .then(response => {
            let _products
            if (productsList.length > 0) {
              _products = response.data.data.filter(res => productsList.filter(p => p.product_id === res.id).length > 0)
            } else {
              _products = response.data.data
            }

            setProducts(_products)
            setFetching(false)
          })
          .catch(err => {
            console.log(err)
            message.error('No se ha podido cargar la información de fabricantes')
          })
      }
    }
  }

  return (
    <>
      <h4 className={'section-space-list-bottom'}>Productos</h4>
      {props.loading ? (
        <UISpinner />
      ) : (
        <List
          id={'inventory-list'}
          size="small"
          rowKey="id"
          dataSource={dataSource}
          renderItem={(row, i) => (
            <List.Item>
              <Row gutter={16} align="bottom" className={'section-space-field w-100'} key={row.id}>
                <Col sm={1}>
                  <div className={'title-space-bottom text-bold'}>{i + 1}</div>
                </Col>
                <Col sm={style.productCol}>
                  <div className={'title-space-field pl-2'}>Elige un producto</div>
                  {props.listType === 'ENTRY' || props.listType === 'TRANSFER' ? (
                    <Select
                      disabled={props.visible && (!Utils.isObjEmpty(props.edit) || props.total === '') ? true : false}
                      className={'single-select'}
                      showSearch
                      value={row.productName}
                      placeholder="Nombre o SKU de presentación"
                      notFoundContent={fetching ? <Spin size="small" /> : null}
                      filterOption={false}
                      onSearch={debounce(fetchPresentations, 800)}
                      onChange={e => onSetData(e, row.id, 'product', true)}
                      size={'large'}
                      style={{ width: '100%' }}
                    >
                      {data.map(d => (
                        <Option key={d.id} value={d.id}>
                          {d.description}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    <Select
                      disabled={props.visible && (!Utils.isObjEmpty(props.edit) || props.total === '' || props.disabled) ? true : false}
                      value={row.productName}
                      className={'single-select'}
                      showSearch
                      placeholder={'Nombre de producto'}
                      filterOption={false}
                      notFoundContent={fetching ? <Spin size="small" /> : null}
                      onChange={product => onSetData(product, row.id, 'product', true)}
                      onSearch={debounce(onSearchProducts, 800)}
                      size={'large'}
                      style={{ width: '100%' }}
                    >
                      {products &&
                        products.map(product => (
                          <Option key={product.id} value={product.id}>
                            {product.description}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Col>
                <Col sm={style.unitsCol} style={{ display: style.unitsColHide ? 'none' : 'block' }}>
                  <div className={'title-space-field text-center'}>No. Unidades</div>
                  <Input
                    disabled={props.visible && (!Utils.isObjEmpty(props.edit) || props.total === '') ? true : false}
                    value={row.units}
                    onChange={e => onSetData(e, row.id)}
                    placeholder={'No. Unidades'}
                    name={'units'}
                    size={'large'}
                  />
                </Col>
                <Col sm={style.priceCol} style={{ display: style.priceColHide ? 'none' : 'block' }}>
                  <div className={'title-space-field text-center'}>Costo unitario</div>
                  <Input
                    disabled={props.visible && (!Utils.isObjEmpty(props.edit) || props.total === '') ? true : false}
                    value={row.price}
                    // onChange={e => onSetData(e, row.id)}
                    onChange={e => {
                      let val = e.target.value;
                      // Solo permite hasta 4 decimales
                      if (val.includes('.')) {
                        const [intPart, decPart] = val.split('.');
                        val = intPart + '.' + decPart.slice(0, 4);
                      }
                      // Solo acepta si es número válido o vacío
                      if (/^\d*\.?\d{0,4}$/.test(val) || val === '') {
                        onSetData({ target: { name: 'price', value: val } }, row.id);
                      }
                    }}
                    placeholder={'Costo unitario'}
                    name={'price'}
                    size={'large'}
                  />
                </Col>
                <Col sm={style.totalCol} style={{ display: style.totalColHide ? 'none' : 'block' }}>
                  <div className={'title-space-field text-center'}>Total</div>
                  <Input disabled={true} value={Number(row.units * row.price).toFixed(2)} placeholder={'Total'} name={'total'} size={'large'} />
                </Col>
                <Col sm={style.remainingCol} style={{ display: style.remainingColHide ? 'none' : 'block' }}>
                  <div className={'title-space-field text-center'}>En inventario</div>
                  <Input
                    disabled={true}
                    value={row.remaining}
                    onChange={e => onSetData(e, row.id)}
                    placeholder={'Cantidad'}
                    name={'remaining'}
                    size={'large'}
                  />
                </Col>
                <Col sm={style.newQuantityCol} style={{ display: style.newQuantityColHide ? 'none' : 'block' }}>
                  <div className={'title-space-field text-center'}>Nueva cantidad</div>
                  {props.disabled ? (
                    <Input
                      disabled={props.disabled}
                      value={''}
                      onChange={e => props.newQuantity(e, row.id)}
                      placeholder={'Cantidad'}
                      name={'newQuantity'}
                      size={'large'}
                    />
                  ) : (
                    <Input onChange={e => props.newQuantity(e, row.id)} placeholder={'Cantidad'} name={'newQuantity'} size={'large'} />
                  )}
                </Col>
                <Col sm={3} className={'center-flex-div'}>
                  {props.visible && !Utils.isObjEmpty(props.edit) ? (
                    ''
                  ) : (
                    <Button type={'link'} className="title-space-bottom cancel-button px-0 m-0" onClick={e => onDelete(e, row.id)}>
                      Eliminar
                    </Button>
                  )}
                </Col>
              </Row>
            </List.Item>
          )}
          footer={
            props.visible && !Utils.isObjEmpty(props.edit) ? (
              ''
            ) : (
              <Row gutter={16} className={'section-space-field'}>
                <Col sm={1}></Col>
                <Col sm={10}>
                  <div className="title-tendero dashed-border-button" onClick={onAdd}>
                    <svg className={'svg'} viewBox="0 0 300 100" preserveAspectRatio="none">
                      <path className={'path'} d="M0,0 300,0 300,100 0,100z" />
                    </svg>
                    <span className={'text'}>Agregar Producto</span>
                  </div>
                </Col>
                <Col sm={13}></Col>
              </Row>
            )
          }
        />
      )}
    </>
  )
}

export default InventoryList

InventoryList.defaultProps = {
  edit: {},
}
